import { render, staticRenderFns } from "./lottery-banner.vue?vue&type=template&id=6c97fe05&scoped=true&"
import script from "./lottery-banner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./lottery-banner.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./lottery-banner.vue?vue&type=style&index=0&id=6c97fe05&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c97fe05",
  null
  
)

export default component.exports